import ArrowRightIcon from '@atlaskit/icon/core/arrow-right';
import * as React from 'react';

export function SvgArrowRight() {
  return <ArrowRightIcon label="" testId="ads-refreshed-icon" />;
}
